import { render } from "./SubscriptionPerkConfigs.vue?vue&type=template&id=034e655a"
import script from "./SubscriptionPerkConfigs.vue?vue&type=script&lang=js"
export * from "./SubscriptionPerkConfigs.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__